import React, { useRef, useEffect } from "react";
import CarouselContent from "./carouselContent";
import { Grid, Card, CardContent, Typography, Box } from "@mui/material";
import Image from "next/image";
import { PaperComponent } from "@/components";
import { GradeRounded } from "@mui/icons-material";

const Carousel = ({
  children,
  carouselSlides,
  activeIndex,
  feedbackCard = false,
  showImages = false,
}) => {
  const slideRefs = useRef([]);

  const scrollToCenter = (index) => {
    slideRefs?.current[index]?.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
    });
  };

  return (
    <Grid
      sx={{
        height: "200%",
        display: "flex",
        gap: 2,
        overflowX: "auto",
        scrollSnapType: "x mandatory",
        gap: 2,
        // pt: 2,
        scrollbarWidth: "none",
        "&::-webkit-scrollbar": {
          display: "none",
        },
      }}
    >
      {carouselSlides?.map((profile, i) => (
        <CarouselContent key={i}>
          {showImages && (
            <Grid item md={6}>
              <Card
                key={profile?.title}
                ref={(el) => (slideRefs.current[i] = el)}
                sx={{
                  minWidth: 200,
                  maxWidth: 300,
                  // flexShrink: 0,
                  scrollSnapAlign: "center",
                  borderRadius: 2,
                  boxShadow: 3,
                  position: "relative",
                }}
              >
                <CardContent sx={{ backgroundColor: "#F6F9F9", p: 0 }}>
                  <>
                    <Image
                      src={profile?.image}
                      alt={profile?.title}
                      loading="lazy"
                    ></Image>

                    <Typography
                      variant="h6"
                      fontWeight={400}
                      sx={{ fontSize: { xs: 14, md: 16 }, px: 2 }}
                    >
                      {profile?.title}
                    </Typography>
                  </>

                  {children}
                </CardContent>
              </Card>
            </Grid>
          )}
          {feedbackCard && (
            <Grid item md={4} position={"relative"}>
              <Box
                sx={{
                  px: 4,
                  pt:4,
                  pb:1,
                  height: 250,
                  border: "1px solid #00413533",
                  borderRadius: 6,
                  width: 400,
                  display:"flex",
                  flexDirection:"column",
                  justifyContent:"space-between"
                }}
              >
                <Box>
                  <Typography fontSize={16}>{profile?.title}</Typography>
                </Box>
                <Box display={"flex"} gap={2}>
                  <Image src={profile.image} alt={profile?.title} />
                    <Box>
                        <Typography fontSize={18} fontWeight={700}>{profile?.name}</Typography>
                        {Array.from({length:profile?.stars}).map((_, index) => (
                            <GradeRounded key={index} sx={{fontSize:20}} color="#F8C917" />
                        ))}
                    </Box>
                </Box>
              </Box>
              <Box></Box>
            </Grid>
          )}
        </CarouselContent>
      ))}
    </Grid>
  );
};

export default Carousel;
